import { QuestionActions } from '../actions/question-action-creators.mjs';

/**
 * This reducer should listen to answer change events and ensure the state is up to date
 */
const localQuestionReducer = (state, action) => {
  switch (action.type) {
    case QuestionActions.ANSWER_VALUE_CHANGED:
    case QuestionActions.CALCULATED_QUESTION_UPDATE_COMPLETED: {
      const {
        question,
        value
      } = action;
      const currentAnswer = state.answers[question.appkey] || {};
      return {
        ...state,
        answers: {
          ...state.answers,
          [question.appkey]: {
            ...currentAnswer,
            appkey: question.appkey,
            timestamp: new Date(),
            value,
            view : {
              attributes: {
                ...question.attributes
              },
              type: question.type,
              ...currentAnswer.view
            },
            loading: false
          }
        }
      };
    }

    case QuestionActions.CALCULATED_QUESTION_UPDATE_STARTED: {
      const {
        question
      } = action;
      return {
        ...state,
        answers: {
          ...state.answers,
          [question.appkey]: {
            ...(state.answers[question.appkey] || {}),
            loading: true
          }
        }
      };
    }

    default:
      return state;
  }
};

export default localQuestionReducer;
